import { render } from "./AiReportQuarterContainer.vue?vue&type=template&id=bc7fb94a&ts=true"
import script from "./AiReportQuarterContainer.vue?vue&type=script&lang=ts"
export * from "./AiReportQuarterContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__